import { PenPlusIcon } from './PenPlusIcon';

/**
 * author: Michael Irigoyen
 * id 299ED912-E240-41D8-AA28-5FB0025BC782
 * name pen-plus
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pen-plus.svg
 * tags
 */
export const PenAddIcon = PenPlusIcon;
export default PenAddIcon